export const INSTRUCTOR_GRADE_POSTING_RELEASE_MESSAGE =
  'Reports will release when grades for this course section are posted.'

export const INSTRUCTOR_RELEASE_UNSET_LABEL = 'Unset'

export const CSV_INSTRUCTOR_RELEASE_CLEAR_TOKEN = 'CLEAR'

/** Runtime default: treat absent API field as disabled (backward compatible). */
export const isInstructorReleaseOnGradePostingEnabled = (value?: boolean): boolean => value === true

export const isInstructorGradePostingReleaseMessage = (value?: string | null): boolean =>
  value === INSTRUCTOR_GRADE_POSTING_RELEASE_MESSAGE
